import { render, staticRenderFns } from "./ChecagemFrigobar.vue?vue&type=template&id=d51b1e96&scoped=true&"
import script from "./ChecagemFrigobar.vue?vue&type=script&lang=js&"
export * from "./ChecagemFrigobar.vue?vue&type=script&lang=js&"
import style0 from "./ChecagemFrigobar.vue?vue&type=style&index=0&id=d51b1e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51b1e96",
  null
  
)

export default component.exports